import { DocumentStatus } from '@synergy/models';
import { createSelector } from 'reselect';
import { hasErrors } from '@synergy/utils';

import { AppState } from '../../../../store/models/app-state';
import { InvoiceSteps } from '../models/invoice-steps';
import { PoolStepperStepStates } from '../../../../common/components/new-stepper/pool-stepper-step-states';
import { isInvoiceTextItem } from '../../models/invoice-item';

export const isRequestingSelector = createSelector(
    (state: AppState) => state.invoiceDetail.common,
    common => common.overviewRequesting || common.positionsRequesting
);

export const invoiceReceiptAlertSelector = (state: AppState) => state.invoiceDetail.common.receiptAlert;

export const invoiceDetailStepperStateSelector = createSelector(
    (state: AppState) => state.invoiceDetail.overview.stepData,
    (state: AppState) => state.invoiceDetail.positions.stepData,

    (overviewState, positionsState) => {
        const result: PoolStepperStepStates = {
            enabledSteps: [InvoiceSteps.Overview],
            errorSteps: [],
            doneSteps: [],
            readonlySteps: [],
        };

        if (!overviewState.values.id) {
            return result;
        }

        result.doneSteps.push(InvoiceSteps.Overview);

        if (positionsState.values.allItems.length > 0) {
            result.doneSteps.push(InvoiceSteps.Positions);
        }
        // Error states
        if (hasErrors(overviewState.errors)) {
            result.errorSteps.push(InvoiceSteps.Overview);
        }
        if (
            hasErrors(positionsState.errors) ||
            positionsState.values.allItems.some(item => !isInvoiceTextItem(item) && item.taxRate === undefined)
        ) {
            result.errorSteps.push(InvoiceSteps.Positions);
        }

        // Enabled states
        result.enabledSteps.push(InvoiceSteps.Positions);

        if (overviewState.values.status !== DocumentStatus.Canceled && result.errorSteps.length === 0) {
            result.enabledSteps.push(InvoiceSteps.Action);
        }

        // Readonly states
        if (
            overviewState.values.status === DocumentStatus.Completed ||
            overviewState.values.status === DocumentStatus.Canceled
        ) {
            result.readonlySteps.push(InvoiceSteps.Overview);
            result.readonlySteps.push(InvoiceSteps.Positions);
        }

        return result;
    }
);
